<!-- 公共行样式组件 -->
<template>
    <div class="commonRow">
        <div class="commonRowTitle">
            <div class="commonRowTitleLeft"></div>
            <div class="commonRowTitleText">{{ title }}</div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped>
.commonRow {
    width: 100%;
    height: auto;
    margin-bottom: 22px;
}

.commonRowTitle {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 4px;
    margin-bottom: 7px;
}

.commonRowTitleLeft {
    width: 3px;
    height: 14px;
    opacity: 1;
    background: var(--h5-color-blue);
}

.commonRowTitleText {
    font-size: 15px;
    font-weight: 700;
    color: var(--h5-color-gray);
}
</style>